import { ShareWithLegalEntitySIDTO, ShareWithLegalEntitySISTO } from "../../models/share-with-legal-entity-si";
import { BaseApiService } from "../base/base-api.service";

export class SharedWithLegalEntitySIApiService extends BaseApiService<
  ShareWithLegalEntitySIDTO,
  ShareWithLegalEntitySISTO
> {
  constructor() {
    super({
      servicePath: "/LegalEntitySIs",
      loadItemsPath: "/GetSharedWithLegalEntitySIs",
      saveItemsPath: "/SaveShareWithLegalEntitySIs",
    });
  }
}
